module.exports = "<app-subsidiary-contract-list></app-subsidiary-contract-list>"